export default __webpack_public_path__ + "static/media/video.3a6fdb12.svg";